const facts = function(value ) {

  //iterate over every element with class fact-text
  document.querySelectorAll('.fact-texts .fact-item').forEach(function (element) {

      if (!element.classList.contains('processed')) {
        // get data-fact-id
        let factId = element.getAttribute('data-fact-id');
        element.addEventListener('click', function () {
          // toggle class active
          document.querySelectorAll('.fact-item').forEach(function (element) {
            element.classList.remove('active');
          });
          document.querySelectorAll('.fact-item[' + 'data-fact-id="' + factId + '"]').forEach(function (element) {
            element.classList.add('active');
          });
        });

        element.classList.add('processed');
      }

    }
  );

  let prev = document.getElementById('fact-prev');
  if (!prev.classList.contains('processed')) {
    prev.addEventListener('click', function () {

      let active = document.querySelector('.fact-item.active');
      let factId = active.getAttribute('data-fact-id');

      document.querySelectorAll('.fact-item').forEach(function (element) {
        element.classList.remove('active');
      });

      if (factId == 1) {
        factId = document.querySelectorAll('.fact-item').length / 2;
      } else {
        factId--;
      }

      document.querySelectorAll('.fact-item[' + 'data-fact-id="' + factId + '"]').forEach(function (element) {
        element.classList.add('active');
      });

    });
    prev.classList.add('processed');

    let next = document.getElementById('fact-next');
    if (!next.classList.contains('processed')) {
      next.addEventListener('click', function () {

        let active = document.querySelector('.fact-item.active');
        let factId = active.getAttribute('data-fact-id');

        document.querySelectorAll('.fact-item').forEach(function (element) {
          element.classList.remove('active');
        });

        if (factId == document.querySelectorAll('.fact-item').length / 2) {
          factId = 1;
        } else {
          factId++;
        }

        document.querySelectorAll('.fact-item[' + 'data-fact-id="' + factId + '"]').forEach(function (element) {
          element.classList.add('active');
        });

      });
      prev.classList.add('processed');

    }
  }
}







export default facts;
